module.exports = __webpack_public_path__ + "product-without-reviews.svg?925dfcb8ff62e98f7fa9ee03a33ae734";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/product-without-reviews.svg
// module id = 316
// module chunks = 2